<i *ngIf="loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
<div *ngIf="showMissingInfoMessage" class="text-warning">
  {{translatePath+'invalid-delivery' | translate}}
</div>
<div class="d-flex flex-column flex-md-row" *ngIf="orderConfirmation">
  <div class="d-flex flex-column w-100">
    <div class="card">
      <div class="card-body">
        <div class="d-flex flex-row align-items-center mb-1 col-12">
          <span class="badge badge-light id-container">
            {{translatePath+'delivery-id' | translate}}  {{' '  + orderConfirmation?.deliveryId}}
          </span>
          <span class="badge badge-pill badge-success ml-1">
            {{'enums.delivery-status.'+deliveryStatusEnum[orderConfirmation.status] | translate}}
          </span>
        </div>
        <h6 class="mb-4 col-12" *ngIf="orderConfirmation?.deliveryContactPerson?.firstName;else generic">
          {{translatePath+'thanks-for-order' | translate:{name:orderConfirmation.deliveryContactPerson.firstName}  }}
        </h6>
        <ng-template #generic>
          <h6 class="mb-4 col-12">
            {{translatePath+'thanks-for-order-generic' | translate  }}
          </h6>
        </ng-template>
        <h6 class="col-12">{{translatePath+'general-info'| translate }}</h6>
        <div class="col-12">
          <hr class="border-grey w-auto col-12 my-2">
        </div>
        <div class="d-flex flex-row w-100">
          <div class="col-6">
            <div class="d-flex flex-column mb-3">
              <span><b>{{translatePath+'delivery-method' | translate}}</b></span>
              <span>{{orderConfirmation.carrier.name}}</span>
              <span>
                {{translatePath+'arrives-between'|translate}}
                {{orderConfirmation.estimatedDeliveryEnd | dateTranslate : 'fullDate'}}
              </span>
              <!-- <span><b>{{orderConfirmation.cost}} MDL</b></span> -->
            </div>
          </div>
          <div class="col-6">
            <div>
              <b>
                {{translatePath+'payment-details' | translate}}
              </b>
            </div>
            <span><b>{{translatePath+'invoice-id' | translate}}</b></span>
            <span class="ml-3"> {{orderConfirmation.invoiceId}}</span>
            <div class="d-flex  mb-3">
              <span><b>{{translatePath+'order' | translate}}</b></span>
              <span class="ml-3">{{orderConfirmation.orderDate | dateTranslate : 'fullDate'}}</span>
            </div>
          </div>
        </div>
        <h6 class="col-12" *ngIf="orderConfirmation?.deliveryContactPerson">
          {{translatePath+'customer-info'| translate }}
        </h6>
        <div class="col-12">
          <hr *ngIf="orderConfirmation?.deliveryContactPerson" class="border-grey w-auto my-2">
        </div>
        <div class="d-flex flex-row w-100"
             *ngIf="orderConfirmation?.deliveryContactPerson">
          <div class="col-6">
            <div class="d-flex flex-column mb-3">
              <span><b>{{translatePath+'personal-info' | translate}}</b></span>
              <span *ngIf="orderConfirmation?.deliveryContactPerson?.firstName">
                {{orderConfirmation?.deliveryContactPerson?.firstName}}
                {{orderConfirmation?.deliveryContactPerson?.lastName}}
              </span>
              <span>{{orderConfirmation?.deliveryContactPerson?.email}}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex flex-column mb-3">
              <span><b>{{translatePath+'shipping-address' | translate}}</b></span>
              <app-address-block *ngIf="orderConfirmation.deliveryAddress" [address]="orderConfirmation.deliveryAddress"></app-address-block>
              <div class="d-flex flex-column" *ngIf="orderConfirmation.internationalDeliveryAddress">
                <span *ngIf="orderConfirmation.internationalDeliveryAddress.street">
                  {{orderConfirmation.internationalDeliveryAddress.street}}
                  &nbsp;
                  {{ orderConfirmation.internationalDeliveryAddress.block}}
                </span>
                <span *ngIf="orderConfirmation.internationalDeliveryAddress.apartment">{{orderConfirmation.internationalDeliveryAddress.apartment}}</span>
                <span *ngIf="orderConfirmation.internationalDeliveryAddress.zipCode">{{orderConfirmation.internationalDeliveryAddress.zipCode}}</span>
                <span *ngIf="orderConfirmation.internationalDeliveryAddress.city">{{ orderConfirmation.internationalDeliveryAddress.city}}</span>
                <span *ngIf="orderConfirmation.internationalDeliveryAddress.country">{{ orderConfirmation.internationalDeliveryAddress.country}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-3 d-flex flex-column  ml-md-5" *ngIf="serviceProviderResponse && orderDetails">
    <app-shipping-summary [order]="orderDetails" [option]="this.option" [providerData]="serviceProviderResponse">
    </app-shipping-summary>
  </div>
</div>
